import React from 'react';
interface FilterPanelProps {
  selectedCategory: string | null;
  selectedPricing: string | null;
  selectedEase: string | null;
  onCategoryChange: (category: string | null) => void;
  onPricingChange: (pricing: string | null) => void;
  onEaseChange: (ease: string | null) => void;
}
export function FilterPanel({
  selectedCategory,
  selectedPricing,
  selectedEase,
  onCategoryChange,
  onPricingChange,
  onEaseChange
}: FilterPanelProps) {
  const categories = ['Writing', 'Design', 'Video', 'Code', 'Audio', 'Research'];
  const pricingOptions = ['Free', 'Freemium', 'Paid'];
  const easeOptions = ['Beginner', 'Pro'];
  return <div className="w-64 space-y-8" data-id="element-16">
      <div data-id="element-17">
        <h3 className="text-sm font-semibold text-black mb-3" data-id="element-18">Use case</h3>
        <div className="space-y-2" data-id="element-19">
          {categories.map(category => <button key={category} onClick={() => onCategoryChange(selectedCategory === category ? null : category)} className={`block w-full text-left text-sm py-1 transition-colors ${selectedCategory === category ? 'text-black font-medium' : 'text-grey-600 hover:text-black'}`} data-id="element-20">
              {category}
            </button>)}
        </div>
      </div>

      <div data-id="element-21">
        <h3 className="text-sm font-semibold text-black mb-3" data-id="element-22">Pricing</h3>
        <div className="space-y-2" data-id="element-23">
          {pricingOptions.map(pricing => <button key={pricing} onClick={() => onPricingChange(selectedPricing === pricing ? null : pricing)} className={`block w-full text-left text-sm py-1 transition-colors ${selectedPricing === pricing ? 'text-black font-medium' : 'text-grey-600 hover:text-black'}`} data-id="element-24">
              {pricing}
            </button>)}
        </div>
      </div>

      <div data-id="element-25">
        <h3 className="text-sm font-semibold text-black mb-3" data-id="element-26">Ease of use</h3>
        <div className="space-y-2" data-id="element-27">
          {easeOptions.map(ease => <button key={ease} onClick={() => onEaseChange(selectedEase === ease ? null : ease)} className={`block w-full text-left text-sm py-1 transition-colors ${selectedEase === ease ? 'text-black font-medium' : 'text-grey-600 hover:text-black'}`} data-id="element-28">
              {ease}
            </button>)}
        </div>
      </div>
    </div>;
}